import React from 'react';
import { LOADER_CSV_STATE, PROPOSAL_STATE, PROGRESS_LOADING, PROGRESS_DONE, SELECT_FULFILLMENT, RESULT_STATE } from '../../../../../redux/kickstarter-shipping/kickstarter-shipping-constants';
import KickstarterShippingProposals from '../kickstarter-shipping-proposals';
import KickstarterShippingCSVLoader from '../kickstarter-shipping-csv-loader';
import KickstarterShippingParsing from '../kickstarter-shipping-parsing';
import KickstarterShippingParseResult from '../kickstarter-shipping-parse-result';
import KickstarterShippingFulfillmentSelector from '../kickstarter-shipping-fulfillment-selector';
function KickstarterShippingStepper({
  step,
  onClose,
  onApproveProposal,
  onCSVUpload,
  uploadState,
  ksFulfillment,
  totalAmount,
  validCount,
  parsingProgress,
  parsingShipmentPrice,
  progressIsDone,
  onChangeStep,
  onAddToOrder,
  invalidAddresses,
  error
}) {
  switch (step) {
    case PROPOSAL_STATE:
      return /*#__PURE__*/React.createElement(KickstarterShippingProposals, {
        onApprove: onApproveProposal,
        onClose: onClose
      });
    case LOADER_CSV_STATE:
      return /*#__PURE__*/React.createElement(KickstarterShippingCSVLoader, {
        onCSVUpload: event => {
          onCSVUpload({
            file: event.target.files[0]
          });
        },
        uploadState: uploadState,
        error: error
      });
    case PROGRESS_LOADING:
    case PROGRESS_DONE:
      return /*#__PURE__*/React.createElement(KickstarterShippingParsing, {
        totalAmount: totalAmount,
        validCount: validCount
        // @ts-ignore
        ,
        ksFulfillment: ksFulfillment,
        invalidAddresses: invalidAddresses,
        parsingProgress: parsingProgress,
        parsingShipmentPrice: parsingShipmentPrice,
        progressIsDone: progressIsDone,
        onChangeStep: onChangeStep,
        onCSVUpload: event => {
          onCSVUpload({
            file: event.target.files[0]
          });
        },
        uploadState: uploadState
      });
    case SELECT_FULFILLMENT:
      {
        return /*#__PURE__*/React.createElement(KickstarterShippingFulfillmentSelector, {
          onChangeStep: onChangeStep,
          nextStep: LOADER_CSV_STATE
        });
      }
    case RESULT_STATE:
      {
        return /*#__PURE__*/React.createElement(KickstarterShippingParseResult
        // @ts-ignore
        , {
          totalAmount: totalAmount,
          validCount: validCount,
          ksFulfillment: ksFulfillment,
          onAddToOrder: onAddToOrder,
          uploadState: uploadState
        });
      }
    default:
      {
        return null;
      }
  }
}
export default KickstarterShippingStepper;